import Joi from 'joi';

export const InformationSchema = Joi.object({
  milestone: Joi.string().required(),
  organization: Joi.string().required(),
  authority: Joi.string().required(),
  visionMission: Joi.string().required(),
});
